import React, { Component } from "react";

class Search extends Component {
  state = {};
  render() {
    return (
      <div>
        <h1>Search Documents</h1>
      </div>
    );
  }
}

export default Search;
